import React, { useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
} from "../../../util/varios";
import TablaDeudaComercio from "./tablaDeudaComercios";
import TablaPagosComercio from "./tablaPagosComercios";
import TablaFacturasContribuyente from "./tablaFacturasContribuyentes";
import TablaHistoricoRetenciones from "./tablaHistoricoRetenciones";
import "react-tabs/style/react-tabs.css";
import TablaRelacionPagosWeb from "./tablaRelacionPagosWeb";
import TablaMultasComercio from "./tablaMultasComercios";
import { Select, Textarea, Input } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton } from "../../../ui/buttons/Button";
export const ActualizarConsultarVerificacionPagosWeb = (props) => {
  let op = require("../../../../src/modulos/datos");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo] = useState();
  const [msg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2] = useState();
  const [msg2] = useState();
  const [activate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const cmbStatus = useRef();

  const handleCloseSi = () => {
    setMostrar1(false);
  };
  const handleCloseNo = () => {
    setMostrar1(false);
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  
  const handleInputNumChange = (event) => {
      validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "inputAnio") {
          txtDescripcionActi.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const imprimirDeudaGeneral = () => {
    var reporte = "Hac_DeudaGeneral";
    window.open(
      op.reportes +
        "reporte=" +
        reporte +
        "&rif=" +
        props.comercio.rif.trim() +
        "&cedula=" +
        props.comercio.reprelegal.trim(),
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const salir = () => {
    props.onHideCancela();
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        console.log(props.tabdeuda);
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setDeclaWeb(props.declaweb);
      }}
    >
      <Modal.Header className = 'col-12 m-0 px-4 py-2 d-flex azulGradiant text-light'>
        <h3 className = 'fw-bold m-0'>
          Detalles de Deuda de Industria y Comercio y Verificación de Pago Web -
          Actividad Economica
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">
            Detalle Deuda Contribuyente Industria y comercio
          </legend>
          <div className="col-6 col-lg-4 m-0 mb-2 p-0">
            <Input label = 'Código Contribuyente:'
              disabled={true}
              defaultValue={props.comercio ? props.comercio.idcomercio : ""}
              id="inputCodigo"
              ref={txtIdComercio}
            />
          </div>
          <div className="col-6 col-lg-2 m-0 mb-2 p-0 pl-2">
            <Input label = 'RITM:'
              disabled={operacion === 1 ? true : deshabilitado}
              defaultValue={props.comercio ? props.comercio.ritm.trim() : ""}
              id="inputRitm"
              onKeyUp={handleInputChange}
              onBlur={handleInputChange}
              ref={txtRitm}
            />
          </div>
          <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-lg-2">
            <Input label = 'Patente:'
              disabled={deshabilitado}
              defaultValue={props.comercio ? props.comercio.codigopatente : ""}
              id="inputNumPatente"
              onKeyUp={handleInputNumChange}
              onBlur={handleInputNumChange}
              ref={txtNumPatente}
            />
          </div>
          <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-2">
            <Select label = 'Status:'
              disabled={deshabilitado}
              defaultValue={
                  props.comercio
                  ? props.comercio.status !== null
                  ? props.comercio.status
                  : ""
                  : ""
                }
                ref={cmbStatus}
            >
              {props.statuscome &&
                props.statuscome.map((sta) => (
                  <option key={sta.idstatus} value={sta.idstatus}>
                    {sta.descripcion.trim()}
                  </option>
                ))}
            </Select>
          </div>
          <div className="col-12 col-lg-6 m-0 mb-2 mb-lg-0 p-0">
            <Textarea label = 'Denominación Comercial:'
              disabled={deshabilitado}
              ref={txtDenominacionCome}
              style={{ height: 70 }}
              defaultValue={props.comercio ? props.comercio.nombre.trim() : ""}
              id="inputDenoComer"
              onKeyUp={handleInputChange}
            />
          </div>
          <div className="col-12 col-lg-6 m-0 p-0 pl-lg-2">
            <Textarea label = 'Dirección del Contribuyente:'
              disabled={deshabilitado}
              ref={txtDireccionContri}
              style={{ height: 70 }}
              id="inputDireccionContri"
              defaultValue={
                props.comercio
                  ? props.comercio.direccion !== null
                    ? props.comercio.direccion.trim()
                    : ""
                  : ""
              }
              onKeyUp={handleInputChange}
            />
          </div>
        </fieldset>

        <ul className="nav d-flex flex-wrap gap-2 mt-2" id="myTab" role="tablist">
          <li className="nav-item col-auto m-0 p-0" role="presentation">
            <a
              className=" rDirección del Contribuyente:ounded nav-link active bg-blue-100 text-light"
              id="datosTributarios"
              data-bs-toggle="tab"
              data-bs-target="#tributarios"
              type="button"
              role="tab"
              aria-controls="tributarios"
              aria-selected="true"
            >
              Deudas Industria y Comercio
            </a>
          </li>
          <li className="nav-item col-auto m-0 p-0" role="presentation">
            <a
              className=" rounded nav-link bg-blue-200 text-light"
              id="deuda-tab"
              data-bs-toggle="tab"
              data-bs-target="#deuda"
              type="button"
              role="tab"
              aria-controls="deuda"
              aria-selected="false"
            >
              Historico Pagos de Industria y Comercio
            </a>
          </li>
          <li className="nav-item col-auto m-0 p-0" role="presentation">
            <a
              className=" rounded nav-link bg-blue-300 text-light"
              id="hist-tab"
              data-bs-toggle="tab"
              data-bs-target="#historico"
              type="button"
              role="tab"
              aria-controls="historico"
              aria-selected="false"
            >
              Relación de Facturas Contribuyentes
            </a>
          </li>
          <li className="nav-item col-auto m-0 p-0" role="presentation">
            <a
              className=" rounded nav-link bg-blue-400 text-light"
              id="multas-tab"
              data-bs-toggle="tab"
              data-bs-target="#multas"
              type="button"
              role="tab"
              aria-controls="multas"
              aria-selected="false"
            >
              Relación de Pagos Web
            </a>
          </li>

          {props.comercio && props.comercio.esagentereten &&
            <li className="nav-item col-auto m-0 p-0" role="presentation">
              <a
                className=" rounded nav-link bg-blue-500 text-light"
                id="relacion-tab"
                data-bs-toggle="tab"
                data-bs-target="#relacion"
                type="button"
                role="tab"
                aria-controls="relacion"
                aria-selected="false"
              >
                Historico Pago Retenciones
              </a>
            </li>
          }
          <li className="nav-item col-auto m-0 p-0" role="presentation">
            <a
              className=" rounded nav-link bg-blue-600 text-light"
              id="multas-tab2"
              data-bs-toggle="tab"
              data-bs-target="#multas2"
              type="button"
              role="tab"
              aria-controls="multas2"
              aria-selected="false"
            >
              Deuda Multas
            </a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="tributarios"
            role="tabpanel"
            aria-labelledby="datosTributarios"
          >
            <TablaDeudaComercio
              tabdeuda={props.tabdeuda}
              credito={props.comercio ? props.comercio.credito : "0,00"}
              idcomercio={props.comercio ? props.comercio.idcomercio : ""}
            />
          </div>

          <div
            className="tab-pane fade"
            id="deuda"
            role="tabpanel"
            aria-labelledby="deuda-tab"
          >
            <TablaPagosComercio
              tabpago={props.tabpago}
              idcomercio={props.comercio ? props.comercio.idcomercio : ""}
            />
          </div>

          <div
            className="tab-pane fade"
            id="historico"
            role="tabpanel"
            aria-labelledby="hist-tab"
          >
            <TablaFacturasContribuyente
              tabfacC={props.tabfacC}
              operacion={operacion}
            />
          </div>

          <div
            className="tab-pane fade"
            id="multas"
            role="tabpanel"
            aria-labelledby="multas-tab"
          >
            <TablaRelacionPagosWeb
              tabpagow={props.tabpagow}
              operacion={operacion}
              declaweb={declaWeb}
              idcomercio={props.comercio ? props.comercio.idcomercio : ""}
            />
          </div>

          {(props.comercio && props.comercio.esagentereten) &&
            <div
              className="tab-pane fade"
              id="relacion"
              role="tabpanel"
              aria-labelledby="relacion-tab"
            >
              <TablaHistoricoRetenciones
                tabreten={props.tabreten}
                operacion={2}
                espiritu={props.espiritu}
              />
            </div>
          }

          <div
            className="tab-pane fade"
            id="multas2"
            role="tabpanel"
            aria-labelledby="multas-tab2"
          >
            <TablaMultasComercio
              tabmulta={props.tabmulta}
              idcomercio={props.comercio ? props.comercio.idcomercio : ""}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton icon = 'fa-print'
          ref={btnAcepta}
          onClick={imprimirDeudaGeneral}
        >
            Imprimir Deuda General
        </InfoButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
            Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
